import { useEffect, useState, useCallback } from 'react'
import { AnnouncementService } from 'utility'
import { ErrorConstant } from 'utility/constant'

export const useAnnouncements = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const fetchData = useCallback(async () => {
        try {
            setLoading(true)
            const list = await AnnouncementService.getAnnouncements()
            setData(list || [])
        } catch (err) {
            setError(err?.error || ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    return { data, error, loading, refresh: fetchData }
}

export const useAnnouncementUnreadCount = () => {
    const [unreadCount, setUnreadCount] = useState(0)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const fetchData = useCallback(async () => {
        try {
            setLoading(true)
            const res = await AnnouncementService.getUnreadCount()
            setUnreadCount(res?.UnreadCount || 0)
        } catch (err) {
            setError(err?.error || ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    return { unreadCount, error, loading, refresh: fetchData }
}
